import { useMemo } from 'react';
import ModalSlider from '../modal-slider/modal-slider';
import BPMC_Collab from '../../../assets/onboarding/2.2/BPMC_Collab.gif';
import BPMC_Drag from '../../../assets/onboarding/2.2/BPMC_Drag.gif';
import BPMC_Q2_Notifs from '../../../assets/onboarding/2.2/BPMC_Q2_Notifs.png';

export function BPMSupremeQ22UpdateCreate() {
    const data = useMemo(
        () => [
            {
                image: BPMC_Collab,
                title: 'Collaborative Drives',
                text: 'Premium and Premium Plus subscribers can now add collaborators to a custom drive to add sounds, share ideas, and create new collections.'
            },
            {
                image: BPMC_Drag,
                title: 'Drag and Drop + Sidebar Improvements',
                text: 'Producers can now drag and drop a sound into a custom drive, as well as select multiple sounds at once to drag and drop to a new drive.'
            },
            {
                image: BPMC_Q2_Notifs,
                title: 'Improved Notifications',
                text: 'Notifications are even more helpful now as they provide actionable links that allow you to preview sounds, add a sound to a drive, and more.'
            }
        ],
        []
    );

    return <ModalSlider title="BPM Create 2.2 Update" type="BPMSupremeQ22UpdateCreate" sliderItems={data} />;
}

export default BPMSupremeQ22UpdateCreate;
